import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArtificialIntelligenceEnhancedIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceEnhancedIcon';
import { TimeIcon } from 'foundations-assets/icons/components/TimeIcon';
import { TwoFAOutlineIcon } from 'foundations-assets/icons/components/TwoFAOutlineIcon';
import { ViewIcon } from 'foundations-assets/icons/components/ViewIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import UsageTracker from 'LearningCenterUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LessonPreQuizStartScreen = ({
  interactionProps,
  onStartQuiz,
  onSkip
}) => {
  const handleStartQuiz = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactionProps, {
      action: 'ai-pre-assessment-started'
    }));
    onStartQuiz();
  };
  const handleSkip = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactionProps, {
      action: 'ai-pre-assessment-skipped-start'
    }));
    onSkip();
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    flexGrow: 1,
    maxInlineSize: "100%",
    padding: "700",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      flexGrow: 1,
      gap: "1500",
      justifyContent: "center",
      maxInlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        gap: "400",
        maxInlineSize: "100%",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexWrap: "wrap",
          gap: "300",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: ArtificialIntelligenceEnhancedIcon,
            size: "700"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-600",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.preAssessmentQuiz.startScreen.title"
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          typography: "heading-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.preAssessmentQuiz.startScreen.subtitle"
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        flexWrap: "wrap",
        gap: "400",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(Button, {
          borderRadius: "full",
          onClick: handleStartQuiz,
          use: "primary",
          children: /*#__PURE__*/_jsx(Text, {
            paddingBlock: "200",
            paddingInline: "1000",
            typography: "heading-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.preAssessmentQuiz.startScreen.takeQuiz"
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          borderRadius: "full",
          onClick: handleSkip,
          use: "secondary",
          children: /*#__PURE__*/_jsx(Text, {
            paddingBlock: "200",
            paddingInline: "1000",
            typography: "heading-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.preAssessmentQuiz.startScreen.skip"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      flexWrap: "wrap",
      gap: "1400",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        gap: "200",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: TwoFAOutlineIcon,
          size: "800"
        }), /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.preAssessmentQuiz.startScreen.benefitConfidence"
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        gap: "200",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: ViewIcon,
          size: "800"
        }), /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.preAssessmentQuiz.startScreen.benefitFocus"
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        gap: "200",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: TimeIcon,
          size: "800"
        }), /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.preAssessmentQuiz.startScreen.benefitTime"
          })
        })]
      })]
    })]
  });
};